<template>
  <div>
    <b-card>
      <label class="text--topic">Generate Report</label>
      <div class="d-flex flex-column flex-lg-row pt-0 mb-2 card-padding">
        <div class="col-12 col-lg-6 p-0 pr-lg-1">
          <label>Generate Report for</label>
          <atom-select
            v-model="selectedMenu"
            label="name"
            placeholder="Generate Report for"
            class="organism-report--generate-report--container-select"
            :option="reportMenuOptions"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
          />
        </div>
        <div
          v-if="selectedMenu && selectedMenu.id !== 7 && selectedMenu.id !== 8"
          class="col-12 col-lg-6 p-0 pl-lg-1 mt-1 mt-lg-0"
        >
          <molecule-date-picker-period
            titleStart="Start Date"
            titleEnd="End Date"
            type="dateNtime"
            v-model="datepicker"
            :maxDate="datepicker.end"
            :minDate="datepicker.start"
            :dateNow="datepicker.now"
          />
        </div>
      </div>
      <hr />

      <div class="card-padding">
        <molecule-report-filter-ticket
          v-if="selectedMenu && selectedMenu.id === 1"
          v-model="ticketManagementFilter"
          :ticket-management-department-option="
            ticketManagementDepartmentOption
          "
          :ticket-management-status-option="ticketManagementStatusOption"
          :ticket-management-priority-option="
            ticketManagementPriorityOption
          "
          :ticket-management-type-option="ticketManagementTypeOption"
          :ticket-management-created-by-option="
            ticketManagementCreatedByOption
          "
        />

        <molecule-report-filter-site-access
          v-if="selectedMenu && selectedMenu.id === 2"
          v-model="siteAccessFilter"
          :site-access-status-option="siteAccessStatusOption"
          :site-access-type-option="siteAccessTypeOption"
          :site-access-ntdc-id-option="siteAccessNtdcIdOption"
        />

        <!-- <molecule-report-filter-smart-hand
          v-if="selectedMenu.id === 3"
          v-model="smartHandFilter"
          :smart-hand-status-option="smartHandStatusOption"
        />

        <molecule-report-filter-cross-connect
          v-if="selectedMenu.id === 4"
          v-model="crossConnectFilter"
          :cross-connect-status-option="crossConnectStatusOption"
          :cross-connect-staff-option="crossConnectStaffOption"
        />

        <molecule-report-filter-parcel-tracking
          v-if="selectedMenu.id === 5"
          v-model="parcelTrackingFilter"
          :parcelTrackingDataTypeOption="parcelTrackingDataTypeOption"
          :parcelTrackingStatusOption="parcelTrackingStatusOption"
        />

        <molecule-report-filter-inventory
          v-if="selectedMenu.id === 6"
          v-model="inventoryFilter"
          :inventoryStatusOption="inventoryStatusOption"
          :inventoryTypeOption="inventoryTypeOption"
        /> -->

        <molecule-report-filter-contract
          v-if="selectedMenu && selectedMenu.id === 7"
          v-model="contractFilter"
          :contractBusinessTypeOptions="contractBusinessTypeOptions"
          :contractStatusOptions="contractStatusOptions"
        />

        <molecule-report-filter-workload
          v-if="selectedMenu && selectedMenu.id === 10"
          v-model="workloadFilter"
          :userScopeOptions="userScopeOptions"
        />

        <div class="row mt-1">
          <div
            class="col-12 d-flex align-items-start justify-content-center justify-content-md-end"
          >
            <!-- <atom-button
            buttonId="organism-report-button-review"
            buttonStyle="flat"
            buttonColor="primary"
            class="organism-report--button-review"
            @click="clickButtonReview"
          >
            <feather-icon icon="EyeIcon" size="14" class="mr-1"></feather-icon>
            <span>Review</span>
          </atom-button> -->
            <atom-button
              buttonId="organism-report-button-export"
              class="organism-report--generate-report--button-export ml-1"
              @click="onClickExport"
            >
              <feather-icon
                icon="ExternalLinkIcon"
                size="14"
                class="mr-1"
              ></feather-icon>
              Export
            </atom-button>
          </div>
        </div>
      </div>
    </b-card>

    <!-- <b-card>
      <label class="text--topic mb-1">Preview</label>

      <organism-report-table-ticket
        :items="ticketPreviewItems"
        :total="ticketTotal"
        :current-page="ticketCurrentPage"
      />
    </b-card> -->
    <footer style="height: 28px"></footer>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue"
import { DateTime } from "luxon"

import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"

import MoleculeDatePickerPeriod from "@/components/molecules/MoleculeDatePickerPeriod.vue"
import MoleculeReportFilterTicket from "@/components/molecules/portal/report/MoleculeReportFilterTicket.vue"
import MoleculeReportFilterSiteAccess from "@/components/molecules/portal/report/MoleculeReportFilterSiteAccess.vue"
import MoleculeReportFilterSmartHand from "@/components/molecules/portal/report/MoleculeReportFilterSmartHand.vue"
import MoleculeReportFilterCrossConnect from "@/components/molecules/portal/report/MoleculeReportFilterCrossConnect.vue"
import MoleculeReportFilterParcelTracking from "@/components/molecules/portal/report/MoleculeReportFilterParcelTracking.vue"
import MoleculeReportFilterInventory from "@/components/molecules/portal/report/MoleculeReportFilterInventory.vue"
import MoleculeReportFilterWorkload from "@/components/molecules/portal/report/MoleculeReportFilterWorkload.vue"

import mixins from "@/mixins"
import mixinsDateTime from "@/mixins/mixinsDatetime"
import mixinsSiteHelper from "@/mixins/mixinsSiteHelper"

import {
  getAllUserList,
  getCustomerNameList,
  getExportReportWebPortal,
  getPreviewReportWebPortal,
  getContractNameList,
} from "@/api/api-module1"
import MoleculeReportFilterContract from "@/components/molecules/portal/report/MoleculeReportFilterContract.vue"
import { getAllDepartmentList } from "@/api/api-module-data"
import { TicketType } from "@/constants"
import { menuOptions, workloadUserScopeOptions } from "@/constants/report"
import mixinsUser from "@/mixins/mixinsUser"
import { mapGetters } from "vuex"
// import OrganismReportTableTicket from "./report/OrganismReportTableTicket.vue"

export default {
  name: "OrganismReport",
  components: {
    BCard,
    AtomSelect,
    MoleculeDatePickerPeriod,
    AtomButton,
    MoleculeReportFilterTicket,
    MoleculeReportFilterSiteAccess,
    MoleculeReportFilterSmartHand,
    MoleculeReportFilterCrossConnect,
    MoleculeReportFilterParcelTracking,
    MoleculeReportFilterInventory,
    MoleculeReportFilterContract,
    MoleculeReportFilterWorkload,
    // OrganismReportTableTicket,
  },
  mixins: [mixins, mixinsDateTime, mixinsSiteHelper, mixinsUser],
  data() {
    return {
      selectedMenu: null,

      datepicker: {
        start: "",
        end: "",
        now: "",
      },
      // start ticket
      ticketManagementFilter: {
        type: [],
        status: null,
        priority: null,
        idcId: "",
        department: null,
        createdBy: null,
      },

      ticketManagementTypeOption: [
        { id: TicketType.NORMAL, name: "Ticket" },
        { id: TicketType.INCIDENT, name: "Incident" },
        { id: TicketType.JOB, name: "Job" },
      ],
      ticketManagementStatusOption: [
        { id: "OPENED", name: "Opened" },
        { id: "IN_PROGRESS", name: "In Progress" },
        { id: "CLOSED", name: "Closed" },
      ],
      ticketManagementPriorityOption: [
        { id: "CRITICAL", name: "Critical" },
        { id: "HIGH", name: "High" },
        { id: "MEDIUM", name: "Medium" },
        { id: "LOW", name: "Low" },
      ],
      ticketManagementDepartmentOption: [],
      ticketManagementCreatedByOption: [],

      ticketPreviewItems: [],
      ticketTotal: 0,
      ticketCurrentPage: 1,

      // start site access
      siteAccessFilter: {
        type: { id: "1", name: "Site Access Summary" },
        status: null,
        ntdc: null,
        ntdcList: null,
      },
      siteAccessStatusOption: [
        { id: "WAITING", name: "Waiting" },
        { id: "APPROVED", name: "Approved" },
        { id: "ACCESS", name: "Access" },
        { id: "CLOSED", name: "Closed" },
        { id: "REJECTED", name: "Rejected" },
      ],
      siteAccessTypeOption: [
        { id: "1", name: "Site Access Summary" },
        { id: "2", name: "Site Access by Customer" },
      ],
      siteAccessCustomerOption: [],
      siteAccessNtdcIdOption: [],

      // start smart hand
      smartHandFilter: {
        customerName: "",
        status: null,
        idcId: "",
      },
      smartHandStatusOption: [
        { id: "WAITING", name: "Waiting" },
        { id: "IN_PROGRESS", name: "In Progress" },
        { id: "COMPLETED", name: "Completed" },
        { id: "DECLINED", name: "Declined" },
      ],

      //cross connect
      crossConnectFilter: {
        customerName: "",
        status: null,
        idcId: "",
        staff: null,
      },
      crossConnectStatusOption: [
        { id: "WAITING", name: "Waiting" },
        { id: "IN_PROGRESS", name: "In Progress" },
        { id: "COMPLETED", name: "Completed" },
        { id: "DECLINED", name: "Declined" },
      ],
      crossConnectStaffOption: [],

      //parcel tracking
      parcelTrackingFilter: {
        customerName: "",
        status: null,
        idcId: "",
        type: { id: "REGISTERED_DATE", name: "Registered Date" },
      },
      parcelTrackingStatusOption: [
        { id: "WAITING", name: "Waiting" },
        { id: "RECEIVED", name: "Received" },
      ],
      parcelTrackingDataTypeOption: [
        { id: "REGISTERED_DATE", name: "Registered Date" },
        { id: "RECEIVED_DATE", name: "Received Date" },
      ],

      //inventory
      inventoryFilter: {
        status: null,
        types: null,
      },
      inventoryStatusOption: [
        { id: "ACTIVE", name: "Active" },
        { id: "EXPIRED", name: "Expired" },
      ],
      inventoryTypeOption: [
        { id: "NETWORK", name: "Network" },
        { id: "ROUTER", name: "Router" },
        { id: "SWITCH", name: "Switch" },
        { id: "FIREWALL", name: "Firewall" },
        { id: "EQUIPMENT", name: "Equipment" },
        { id: "RACK", name: "Rack" },
        { id: "SERVER", name: "Server" },
        { id: "SOFTWARE", name: "Software" },
      ],

      contractFilter: {
        startMonth: { id: 1, name: "January" },
        startYear: DateTime.now().year,
        endMonth: null,
        endYear: DateTime.now().year,
        statuses: [],
        businessTypes: [],
      },

      contractStatusOptions: [
        { id: 1, name: "Approved" },
        { id: 2, name: "Expired" },
        { id: 3, name: "Suspended" },
        { id: 4, name: "Pending" },
      ],

      contractBusinessTypeOptions: [
        { id: 1, name: "ราชการ" },
        { id: 2, name: "รัฐวิสาหกิจ" },
        { id: 3, name: "เอกชน" },
        { id: 4, name: "เอ็นที" },
      ],

      workloadFilter: {
        user: { name: "Only Me", value: "ONLY_ME" },
      },
    }
  },
  computed: {
    ...mapGetters("siteStore", ["siteSetting", "siteOptions"]),
    ...mapGetters("authStore", ["getUsername"]),

    siteIdsSelect() {
      return this.siteOptions.map((site) => site.value) || []
    },

    reportMenuOptions() {
      return menuOptions.filter((option) =>
        this.hasPermission(option.permission)
      )
    },

    userScopeOptions() {
      return workloadUserScopeOptions
        .filter((option) => this.hasPermission(option.permission))
        .map((option) => {
          return { name: option.name, value: option.value }
        })
    },
  },
  async mounted() {
    this.datepicker = {
      start: DateTime.now()
        .minus({ days: 1 })
        .set({ second: 0, millisecond: 0 })
        .toISO({
          suppressSeconds: true,
          suppressMilliseconds: true,
          includeOffset: false
        }),
      end: DateTime.now()
        .set({ second: 0, millisecond: 0 })
        .toISO({
          suppressSeconds: true,
          suppressMilliseconds: true,
          includeOffset: false
        }),
      now: DateTime.now()
        .set({ second: 0, millisecond: 0 })
        .toISO({
          suppressSeconds: true,
          suppressMilliseconds: true,
          includeOffset: false
        }),
    }
    await this.getDepartmentOption()
    await this.getUserOption()
    await this.getNtdcList()
    this.setDefaultSelectedMenu()
  },
  methods: {
    async getDepartmentOption() {
      this.showLoading(true)
      this.ticketManagementDepartmentOption = []
      const params = {
        siteIds: this.siteOptions.map((site) => site.value),
      }
      await getAllDepartmentList(params)
        .then((response) => {
          this.ticketManagementDepartmentOption = response.data?.map(
            (item) => {
              return {
                id: item.departmentId,
                name: `${item.siteName}: ${item.departmentName}`,
              }
            }
          )

          this.ticketManagementDepartmentOption.sort((a, b) => {
            let nameFirst = a.name.toLowerCase()
            let nameTwo = b.name.toLowerCase()
            if (nameFirst < nameTwo) return -1
            if (nameFirst > nameTwo) return 1
            return 0
          })
        })
        .finally(() => this.showLoading(false))
    },

    async getUserOption() {
      this.showLoading(true)
      const params = {
        siteIds: this.siteOptions.map((site) => site.value),
      }
      await getAllUserList(params)
        .then((response) => {
          const userOption = response.map((user) => ({
            username: user.username,
            name: `${user.firstName} ${user.lastName}`,
          }))
          this.crossConnectStaffOption = userOption
          this.ticketManagementCreatedByOption = userOption
        })
        .finally(() => this.showLoading(false))
    },

    async getNtdcList() {
      this.showLoading(true)
      await getContractNameList()
        .then((response) => {
          if (response) {
            this.siteAccessNtdcIdOption = response.map((contract) => {
              return {
                id: contract.contractId,
                name: contract.customer.customerOrganizationName,
                text: `${contract.contractId
                  .toString()
                  .padStart(8, "0")} ${
                  contract.customer.customerOrganizationName
                }`,
              }
            })
          }
        })
        .finally(() => this.showLoading(false))
    },

    async exportTicketManagement() {
      this.showLoading(true)

      const body = {
        ticketTypes: this.ticketManagementFilter.type.length
          ? this.ticketManagementFilter.type.map((item) => item.id)
          : undefined,
        status: this.ticketManagementFilter.status?.id || undefined,
        priority: this.ticketManagementFilter.priority?.id || undefined,
        contractId: this.ticketManagementFilter.idcId || undefined,
        department:
          this.ticketManagementFilter.department?.id || undefined,
        startDate: this.removeSetTimeZone(this.datepicker.start),
        endDate: this.removeSetTimeZone(this.datepicker.end),
        siteIds: this.siteIdsSelect,
        openedBys: this.ticketManagementFilter.createdBy
          ? [this.ticketManagementFilter.createdBy.username]
          : undefined,
      }
      await getExportReportWebPortal("ticket", body, "Ticket_Management")
        .then((response) => {
          if (response) this.handleExportReportSuccess(response)
        })
        .catch((error) => this.handleExportReportError(error))
        .finally(() => this.showLoading(false))
    },

    async exportSiteAccess() {
      this.showLoading(true)
      const body = {
        startDate: this.removeSetTimeZone(this.datepicker.start),
        endDate: this.removeSetTimeZone(this.datepicker.end),
        statuses:
          this.siteAccessFilter.type.id === "2"
            ? this.siteAccessFilter.status?.length
              ? this.siteAccessFilter.status?.map((status) => status.id)
              : this.siteAccessStatusOption.map((status) => status.id)
            : undefined,
        contractIds:
          this.siteAccessFilter.type.id === "1"
            ? this.siteAccessFilter?.ntdcList?.map((ntdc) => ntdc.id)
            : [this.siteAccessFilter.ntdc.id],
        // customerIds:
        //   this.siteAccessFilter.type.id === "1"
        //     ? this.siteAccessFilter?.customerList?.map(
        //         (customer) => customer.id
        //       )
        //     : [this.siteAccessFilter.customer.id],
        siteIds: this.siteIdsSelect,
      }

      await getExportReportWebPortal(
        "site-access",
        body,
        this.siteAccessFilter.type.id === "1"
          ? "Site_Access_Summary"
          : `Site_Access_by_${this.siteAccessFilter.ntdc.name}`
      )
        .then((response) => {
          if (response) this.handleExportReportSuccess(response)
        })
        .catch((error) => this.handleExportReportError(error))
        .finally(() => this.showLoading(false))
    },

    // async exportSmartHand() {
    //   this.showLoading(true)
    //   const body = {
    //     idcId: this.smartHandFilter.idcId || undefined,
    //     customerName: this.smartHandFilter.customerName || undefined,
    //     status: this.smartHandFilter.status?.id || undefined,
    //     startDate: this.removeSetTimeZone(this.datepicker.start),
    //     endDate: this.removeSetTimeZone(this.datepicker.end),
    //     siteIds: this.siteIdsSelect,
    //   }
    //   await getExportReportWebPortal("smart-hand", body, "Smart_Hands")
    //     .catch((error) => this.handleExportReportError(error))
    //     .finally(() => this.showLoading(false))
    // },

    // async exportCrossConnect() {
    //   this.showLoading(true)
    //   const body = {
    //     idcId: this.crossConnectFilter.idcId || undefined,
    //     customerName: this.crossConnectFilter.customerName || undefined,
    //     status: this.crossConnectFilter.status?.id || undefined,
    //     staffId: this.crossConnectFilter.staff?.username || undefined,
    //     startDate: this.removeSetTimeZone(this.datepicker.start),
    //     endDate: this.removeSetTimeZone(this.datepicker.end),
    //     siteIds: this.siteIdsSelect,
    //   }
    //   await getExportReportWebPortal("cross-connect", body, "Cross_Connect")
    //     .catch((error) => this.handleExportReportError(error))
    //     .finally(() => this.showLoading(false))
    // },

    // async exportParcelTracking() {
    //   const body = {
    //     idcId: this.parcelTrackingFilter.idcId || undefined,
    //     customerName: this.parcelTrackingFilter.customerName || undefined,
    //     status: this.parcelTrackingFilter.status?.id || undefined,
    //     dateType: this.parcelTrackingFilter.type?.id || undefined,
    //     startDate: this.removeSetTimeZone(this.datepicker.start),
    //     endDate: this.removeSetTimeZone(this.datepicker.end),
    //     siteIds: this.siteIdsSelect,
    //   }
    //   await getExportReportWebPortal("parcel", body, "Parcel_Tracking")
    //     .catch((error) => this.handleExportReportError(error))
    //     .finally(() => this.showLoading(false))
    // },

    // async exportInventory() {
    //   this.showLoading(true)
    //   const body = {
    //     status: this.inventoryFilter.status?.id || undefined,
    //     type: this.inventoryFilter.types?.length
    //       ? this.inventoryFilter.types.map(({ id }) => id)
    //       : undefined,
    //     startDate: this.removeSetTimeZone(this.datepicker.start),
    //     endDate: this.removeSetTimeZone(this.datepicker.end),
    //     siteIds: this.siteIdsSelect,
    //   }
    //   await getExportReportWebPortal("inventory", body, "Inventory")
    //     .catch((error) => this.handleExportReportError(error))
    //     .finally(() => this.showLoading(false))
    // },

    async exportNtdcContract() {
      this.showLoading(true)

      const startDate = DateTime.local(
        this.contractFilter.startYear,
        this.contractFilter.startMonth.id,
        2
      ).toString()

      const endDate = DateTime.local(
        this.contractFilter.endYear,
        this.contractFilter.endMonth.id,
        25
      ).toString()

      const statuses =
        this.contractFilter.statuses.length > 0
          ? this.contractFilter.statuses.map((item) => item.name)
          : this.contractStatusOptions.map((item) => item.name)

      const businessTypes =
        this.contractFilter.businessTypes.length > 0
          ? this.contractFilter.businessTypes.map((item) => item.name)
          : this.contractBusinessTypeOptions.map((item) => item.name)

      const body = {
        startDate,
        endDate,
        statuses,
        businessTypes,
        siteIds: this.siteIdsSelect,
      }

      await getExportReportWebPortal("contract", body, "Contract")
        .then((response) => {
          if (response) this.handleExportReportSuccess(response)
        })
        .catch((error) => this.handleExportReportError(error))
        .finally(() => this.showLoading(false))
    },

    async exportIpAddress() {
      this.showLoading(true)
      const body = {
        siteIds: this.siteIdsSelect,
      }
      await getExportReportWebPortal("subnet", body, "IP_Address")
        .then((response) => {
          if (response) this.handleExportReportSuccess(response)
        })
        .catch((error) => this.handleExportReportError(error))
        .finally(() => this.showLoading(false))
    },

    async exportWorkload() {
      // TODO: Integrate with API Export Workload Report
      this.showLoading(true)
      const body = {
        startDate: this.removeSetTimeZone(this.datepicker.start),
        endDate: this.removeSetTimeZone(this.datepicker.end),
        siteIds: this.siteIdsSelect,
        isAllUsers: this.workloadFilter.user.value === "ALL_USERS",
        username: this.getUsername,
      }
      await getExportReportWebPortal("workload", body, "Workload")
        .then((response) => {
          if (response) this.handleExportReportSuccess(response)
        })
        .catch((error) => this.handleExportReportError(error))
        .finally(() => this.showLoading(false))
    },

    handleExportReportSuccess(response) {
      if (response?.status === 200) {
        this.toastSuccess("Report exported successfully")
      } else if (response?.status === 204) {
        this.toastWarning("No data for generate report")
      }
    },

    handleExportReportError(error) {
      if (error.response.status === 404) {
        this.toastWarning("No data for generate report")
      } else {
        this.toastError("Cannot export report")
      }
    },

    async previewTicketManagement() {
      this.showLoading(true)
      const body = {
        ticketTypes: this.ticketManagementFilter.type.length
          ? this.ticketManagementFilter.type.map((item) => item.id)
          : undefined,
        status: this.ticketManagementFilter.status?.id || undefined,
        priority: this.ticketManagementFilter.priority?.id || undefined,
        contractId: this.ticketManagementFilter.idcId || undefined,
        department:
          this.ticketManagementFilter.department?.id || undefined,
        startDate: this.removeSetTimeZone(this.datepicker.start),
        endDate: this.removeSetTimeZone(this.datepicker.end),
      }
      await getPreviewReportWebPortal("ticket", body)
        .then((response) => {
          this.ticketPreviewItems = response.data
          this.ticketTotal = response.totalCount
          this.ticketCurrentPage = response.currentPage
        })
        .finally(() => this.showLoading(false))
    },

    onClickExport() {
      switch (this.selectedMenu.id) {
        case 1:
          this.exportTicketManagement()
          break
        case 2:
          this.exportSiteAccess()
          break
        // case 3:
        //   this.exportSmartHand()
        //   break
        // case 4:
        //   this.exportCrossConnect()
        //   break
        // case 5:
        //   this.exportParcelTracking()
        //   break
        // case 6:
        //   this.exportInventory()
        //   break
        case 7:
          this.exportNtdcContract()
          break
        case 8:
          this.exportIpAddress()
          break
        case 10:
          this.exportWorkload()
          break

        default:
          break
      }
    },

    clickButtonReview() {
      switch (this.selectedMenu.id) {
        case 1:
          this.previewTicketManagement()
          break

        default:
          break
      }
    },

    setDefaultSelectedMenu() {
      this.selectedMenu = this.reportMenuOptions[0]
    },
  },
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 0;
}

.card-padding {
  padding: 1.5rem;
}
.text--topic {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
  padding: 1.5rem;
}

.organism-report--button-review:focus {
  background-color: #ffffff;
}
</style>
